import React, { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AdminService from "../../../../services/AdminService";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import RoleService from "../../../../services/RoleService";

const AddAdmin = () => {
	const location = useLocation();
	const [formData, setFormData] = useState({
		username: "",
		email: "",
		phone: "",
		role: "",
		password: "",
	});
	const [isAdd, setIsAdd] = useState(true);
	const [loading, setLoading] = useState(false);
	const [rolesOptions, setRolesOptions] = useState([]);
	const [showPassword, setShowPassword] = useState(false);
	const navigate = useNavigate();
	const adminService = new AdminService();
	const lang = useSelector((state) => state.auth?.lang);

	useEffect(() => {
		new RoleService().getList().then((res) => {
			if (res?.status) {
				const response = res?.data?.data?.data?.map((info) => {
					return {
						label: info?.name,
						value: info?.id,
					};
				});
				setRolesOptions(response);
			}
		});

		if (location?.state?.edit) {
			setIsAdd(false);
			let item = location.state?.item;
			setFormData({
				username: item?.username,
				email: item?.email,
				phone: item?.phone,
				password: "",
				role: !!item.admin_permissions?.length
					? {
							label: item.admin_permissions[0]?.admin_role?.name,
							value: item.admin_permissions[0]?.admin_role_id,
					  }
					: "",
			});
		}
	}, []);

	const inputHandler = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const onSubmit = (e) => {
		e.preventDefault();
		if (!formData.role) {
			toast.error("Select Role");
			return;
		}

		let phoneEdited = formData?.phone;
		if (formData?.phone?.startsWith("+965"))
			phoneEdited = formData?.phone?.replace("+965", "");
		if (formData?.phone?.startsWith("965"))
			phoneEdited = formData?.phone?.replace("965", "");
		let data = {
			username: formData?.username,
			email: formData?.email,
			role_id: formData.role?.value,
			country_code: "+965",
			phone: phoneEdited,
		};
		if (location?.state?.edit) {
			if (!!formData?.password) data["password"] = formData?.password;
			setLoading(true);
			adminService.update(location.state?.id, data).then((response) => {
				if (response?.status === 200) {
					toast.success("Admin Updated Successfully");
					navigate("/admins");
				}
				setLoading(false);
			});
		} else {
			data["password"] = formData?.password;

			setLoading(true);
			adminService.create(data).then((response) => {
				if (response?.status === 201) {
					toast.success(
						`${Translate[lang].added} ${Translate[lang].admin} ${Translate[lang].successfully}`
					);
					navigate("/admins");
				}
				setLoading(false);
			});
		}
	};

	return (
		<>
			<div
				className="d-flex align-items-center"
				style={{ gap: "8px", margin: "12px 0 32px" }}>
				<svg
					style={{ cursor: "pointer" }}
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					onClick={() => navigate("/admins")}>
					<path
						d="M9.57 5.92993L3.5 11.9999L9.57 18.0699"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M20.4999 12H3.66992"
						stroke="#1E1F24"
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>

				<label className="mb-0" style={{ fontSize: "20px", fontWeight: "600" }}>
					{!isAdd ? Translate[lang]?.edit : Translate[lang]?.add}{" "}
					{Translate[lang]?.admins}
				</label>
			</div>
			<Card className="p-4">
				<AvForm onValidSubmit={onSubmit}>
					<div className="row">
						<div className="col-lg-6 col-sm-6">
							<AvField
								label={`${Translate[lang]?.name}`}
								name="username"
								type="text"
								value={formData?.username}
								errorMessage="Please enter a valid First Name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								placeholder={`${Translate[lang]?.name}`}
								onChange={(e) => inputHandler(e)}
							/>
						</div>
						<div className="col-lg-6 col-sm-6">
							<AvField
								label={`${Translate[lang]?.email}`}
								name="email"
								type="email"
								value={formData?.email}
								errorMessage="Please enter a valid Email"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								placeholder="example@example.com"
								onChange={(e) => inputHandler(e)}
							/>
						</div>
						<div className="col-lg-6 col-sm-6">
							<AvField
								label={`${Translate[lang]?.password}`}
								name="password"
								type={`${showPassword ? "password" : "text"}`}
								value={formData?.password}
								errorMessage="Please enter a valid Password"
								validate={{
									required: {
										value: !location?.state?.edit,
										errorMessage: Translate[lang].field_required,
									},
								}}
								onFocus={(e) => setShowPassword(false)}
								onBlur={(e) => setShowPassword(true)}
								placeholder={`${Translate[lang]?.password}`}
								onChange={(e) => inputHandler(e)}
							/>
						</div>
						<div className="col-lg-6 col-sm-6">
							<label className="text-label">{Translate[lang]?.role}</label>
							<Select
								value={formData?.role}
								name="role"
								placeholder={Translate[lang]?.select}
								options={rolesOptions}
								onChange={(e) => setFormData({ ...formData, role: e })}
							/>
						</div>
						<div className="col-lg-6 col-sm-6">
							<AvField
								label={`${Translate[lang]?.phone}`}
								name="phone"
								type="number"
								value={formData?.phone}
								errorMessage="Please enter a valid Phone"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								placeholder={`${Translate[lang]?.phone}`}
								onChange={(e) => inputHandler(e)}
							/>
						</div>
					</div>
					<div className="d-flex justify-content-between mt-4">
						<Button
							variant="secondary"
							type="button"
							onClick={() => navigate("/admins")}>
							{Translate[lang]?.cancel}
						</Button>
						<Button variant="primary" type="submit" disabled={loading}>
							{Translate[lang]?.submit}
						</Button>
					</div>
				</AvForm>
			</Card>
		</>
	);
};

export default AddAdmin;
